class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.closest("carousel-slider");
    this.recommendationsUrl = this.getAttribute("data-recommendations-url");
    this.recommendationsIds = this.getAttribute("data-recommendations-ids");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.getRecommendations();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  getRecommendations() {
    if (this.recommendationsUrl) {
      this.innerHTML = "";
      this.addRecommendations(this.recommendationsUrl);
    } else {
      let ids = this.recommendationsIds ? this.recommendationsIds.split(",") : [];
  
      if (window.cart.items_count === 0 || window.cart.items_count === undefined) {
        const defaultProductId = `${window.productRecommendationId}`;
        ids = [defaultProductId];
      }
  
      if (ids.length) {
        const productLimit = Math.round(10 / ids.length);
        this.innerHTML = "";
        ids.forEach((productId) => {
          let intent;
          if (this.closest('#section-mini-cart-recommendations') || window.template == 'cart') {
            intent = 'complementary';
          } else if (this.closest('.section-carousel')) {
            intent = 'related';
          }
  
          this.addRecommendations(
            window.recommendationsUrl +
              `&product_id=${productId}&limit=${productLimit}&intent=${intent}`
          );
        });
      }
    }
  }

  addRecommendations(url) {
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("div");
        this.innerHTML += recommendations.innerHTML;
      })
      .finally(() => {
        this.carousel.dispatchEvent(new Event("trigger-init"));
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    window.cart = cart;
    window.cart.items_count = cart.item_count;
  })
  .then(() => {
    // Initialize ProductRecommendations after cart data is fetched
    customElements.define('product-recommendations', ProductRecommendations);
  });
